import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonNav } from "@ionic/vue"
  import LoginAs from "@/views/LoginAs.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginRouter',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonNav), { root: LoginAs }))
}
}

})